/* eslint-disable react-hooks/exhaustive-deps */
// React Imports
import { useEffect, useRef, useState } from "react";

// Router Imports
import { useLocation, useNavigate } from "react-router-dom";

// Redux Imports
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources.js";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  reimbursementRequestApproval,
  ReimbursementRequestDeniedApproval,
} from "../../../redux/features/reimbursementRequest/index.js";

// Utils Imports
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  RejectReasonLength,
} from "../../../utils/configurationProvider.js";
import TEXT from "../../../utils/globalText.js";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";

// Component Imports
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons/index.js";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import ReimbursementAccountDetailsPopup from "../../../components/_utils/ReimbursementAccountDetailsPopup/index.jsx";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast/index.jsx";
import Loader from "../../../components/Loader/Index.jsx";
import ReimbursementReqTxnDetailsPopup from "../../../components/ReimbursementRequest/ReimbursementReqTxnDetailsPopup/index.jsx";
import UseHandleScroll from "../../../hooks/useHandleScroll.js";

const DeclinedRed = ICONS.REJECTED_RED;
const FailedToAction = ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;

const ReimbursementRequestSingleApproval = () => {
  // 1️⃣ useDispatch & Router hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[0],
  });

  // 2️⃣ useRef
  const filterBGRef = useRef(null);
  const filterParentDivRef = useRef(null);

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const categories = useSelector(
    (state) => state?.sharedResources.categoriesData?.categories,
  );

  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);

  // 3️⃣ useState
  const [page, setPage] = useState(
    Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat"),
  );
  const [showPopup, setShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [declineReason, setDeclineReason] = useState("");
  const reasonLength = declineReason.trim().length;
  const isReasonValid =
    reasonLength >= GlobalConfiguration.rejectReasonMinLength;
  const reasonVariant =
    reasonLength === 0 ? "default" : isReasonValid ? "verified" : "error";
  const [showLoader, setShowLoader] = useState(false);
  const [loading] = useState({});
  const [openRequestpopup, setopenRequestpopup] = useState(false);
  const [currentAccountDetails, setcurrentAccountDetails] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    labels: [],
    ownerLabels: [],
    comment: "",
    date: "",
    expenseType: "",
    description: "",
    uploadFile: "",
  });
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [AllReimburseTxnAccounts, setAllReimburseTxnAccounts] = useState([]);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [label, setlabel] = useState(searchParam.get("category") || "");
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [mainData, setMainData] = useState([]);
  const [RequestId, setRequestId] = useState("");
  const [showSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [currentBtnClicked, setCurrentBtnClicked] = useState({});
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);

  // 4️⃣ useSelector
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const { reimbursementRequestApprovalData } = useSelector(
    (state) => state.reimbursementRequest,
  );
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  // 5️⃣ Callback / Handler functions
  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value
      .replace(/[^a-zA-Z0-9\s]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleReject = async (id, reason) => {
    try {
      if (
        services?.find(
          (service) =>
            service === "AReimbursementRequest" || service === "Admin",
        ) === undefined
      ) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "AReimbursementRequest, Admin" },
        });
        return;
      }

      // Token check
      if (!sessionStorage.getItem("q2p_token")) {
        return;
      }

      setShowLoader(true);

      showLoadingToast("Rejecting requests");

      const result = await dispatch(
        ReimbursementRequestDeniedApproval({
          id,
          AccountIdData: declineReason,
        }),
      );

      const payload = result?.payload;

      // wait for loader animation
      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "AReimbursementRequest, Admin" },
        });
        return;
      }

      const updatedData = AllReimburseTxnAccounts.map((item) => {
        if (item.request_id !== id) return item;

        const tx = payload?.requests?.[0];
        let lifecycleStatus = "error";
        let errorMessage = "";

        if (payload?.status === true) {
          lifecycleStatus =
            tx?.lifecycle_status === "rejected"
              ? "rejected"
              : tx?.lifecycle_status === "pending"
                ? "pendingOne"
                : "error";
        }

        if (payload?.errors?.base?.[0]?.errors) {
          errorMessage = payload.errors.base[0].errors[0];
        } else if (payload?.errors?.base?.[0]) {
          errorMessage = payload.errors.base[0];
        }

        return {
          ...item,
          lifecycle_status:
            item.lifecycle_status === "pending" && payload?.status === true
              ? lifecycleStatus
              : "error",
          rejected: true,
          rejection_reason: reason,
          error: payload?.status === false ? "true" : "false",
          message: payload?.status === false ? errorMessage : "",
        };
      });

      updateAllTxn(updatedData);

      if (payload?.status === false) {
        CommonToast({
          text:
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowPopup(false);
        setDeclineReason("");
      } else {
        CommonToast({
          text: "Request rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowPopup(false);
        setDeclineReason("");
      }
    } catch (error) {
      console.error("Reject txn failed:", error);

      CommonToast({
        text: "Something went wrong. Please try again.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowPopup(false);
      setDeclineReason("");
    } finally {
      setShowLoader(false);
    }
  };

  const fetchSearchDropdownData = async () => {
    setLoadingData(true);

    if (active === "Category") {
      const res = await dispatch(
        getAllCategories({ search_string: searchUserTextDebounce }),
      );

      const categories = res?.payload?.categories || [];

      setInputData(
        categories.map((c) => ({
          id: c.id,
          Category: c.name,
          Description: c.description || "Not given",
        })),
      );
    }

    setLoadingData(false);
  };

  const handleClearFilters = () => {
    setCurrentCategory("");
    setSearchUserTextDebounce("");
    setlabel("");
    setPage(GlobalConfiguration.lengthCheckOne);
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${dropdownOptions[0]}`,
      },
      { replace: true },
    );
  };

  useEffect(() => {
    if (active) fetchSearchDropdownData();
  }, [active]);

  useEffect(() => {
    onMount();
  }, [page, pageSize, currentCategory, markerData]);

  const onMount = () => {
    setAllBeneTxnAccountsLoading(true);

    dispatch(
      reimbursementRequestApproval({
        page_no: page,
        page_size: pageSize,
        category_id: currentCategory ?? undefined,
      }),
    )
      .then((response) => {
        const newData = (response?.payload?.requests || []).map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        }));

        setAllReimburseTxnAccounts(newData);
        setMainData(response?.payload);
        setAllBeneTxnAccountsLoading(false);
      })

      .catch(() => {
        setAllBeneTxnAccountsLoading(false);
      });
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
  };

  const handlePagination = (pageNum) => {
    setPage(pageNum);
    handleSearchParams("pageno", pageNum);
  };

  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };

  const updateAllTxn = (updatedTxn) => {
    setAllReimburseTxnAccounts(updatedTxn);
  };

  const handleFilterCategory = () => {
    setCurrentCategory(label);
    setAllReimburseTxnAccounts([]);
    if (page === GlobalConfiguration.lengthCheckOne) {
      setAllBeneTxnAccountsLoading(true);
    }
    setFilterOpen(false);
  };
  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(page) || GlobalConfiguration.lengthCheckOne;
    setPage(nextPage);
    handleSearchParams("pagesize", value);
    handleSearchParams("pageno", nextPage);
  };

  const hasAnyFilter =
    (currentCategory &&
      currentCategory.length > GlobalConfiguration.lengthCheckZero) ||
    (searchUserTextDebounce &&
      searchUserTextDebounce.length > GlobalConfiguration.lengthCheckZero);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    AllReimburseTxnAccounts.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [label, filterOpen]);

  useEffect(() => {
    const handleFilter = (e) => {
      if (
        filterBGRef.current &&
        filterBGRef.current.contains(e.target) &&
        filterParentDivRef.current &&
        !filterParentDivRef.current.contains(e.target)
      ) {
        setFilterOpen(false);
      }
    };

    document.addEventListener("click", handleFilter);

    return () => {
      document.removeEventListener("click", handleFilter);
    };
  }, [filterBGRef, filterParentDivRef]);

  useEffect(() => {
    if (label === "") {
      setCurrentCategory("");
    }
  }, [label]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, IntervalConfiguration.intervalExtraSmall);
    }
  }, [ownerAccBalanceLoading]);

  const getTxnOverlayConfig = ({
    account,
    loading,
    openTxn,
    openAccountDrawer,
  }) => {
    const isError =
      account.lifecycle_status === "error" &&
      account.error === "true" &&
      !loading[account.request_id];

    const isRejected =
      account.lifecycle_status === "rejected" &&
      account.error === "false" &&
      !loading[account.request_id];

    const isAccountApprovalPending =
      account.lifecycle_status === "pending" &&
      account.beneficiary_account_approval_status === "pending" &&
      !loading[account.request_id];

    const isTxnApprovalPending =
      (account.lifecycle_status === "pending" || loading[account.request_id]) &&
      account.beneficiary_account_approval_status === "approved";

    const hasAccountApprovalAccess =
      services?.includes("RAAccount") && services.includes("RVAccount");

    if (isError) {
      return {
        cardState: "single",
        overlay1Icon: FailedToAction,
        overlay1Text: "Failed to take action!",
        overlay1Subtext: account.message,
        overlay1CtaText: "View request",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Color: "var(--negative-act)",
        allowApproveReject: false,
      };
    } else if (isRejected) {
      return {
        cardState: "double",
        overlay1Icon: DeclinedRed,
        overlay1Text: "Rejected",
        overlay1Subtext: "This request has been rejected!",
        overlay1CtaText: "View request",
        overlay1CtaOnClick: openTxn,
        overlay2Text: "Rejected reason",
        overlay2Subtext: account.rejection_reason,
        allowApproveReject: false,
      };
    } else if (isAccountApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: null,
        overlay1Text: "Account approval pending",
        overlay1Subtext:
          "Account is not approved, please approve account before approving request.",
        overlay1CtaText: "Approve account",
        overlay1SubtextColor: "var(--pending)",
        overlay1CtaOnClick: () => {
          if (hasAccountApprovalAccess) {
            openAccountDrawer();
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "RAAccount, RVAccount" },
            });
          }
        },

        allowApproveReject: false,
      };
    } else if (isTxnApprovalPending) {
      return {
        cardState: "default",
        allowApproveReject:
          services?.includes("AReimbursementRequest") ||
          services?.includes("Admin"),
      };
    } else {
      return {
        cardState: "default",
        allowApproveReject: false,
      };
    }
  };

  return (
    <>
      {!(noTransactionsFromAPI || noResultsAfterFilter) && (
        <div
          className={`fixed w-full bottom-bottom-base ${allBeneTxnAccountsLoading && "hidden"} z-z-index-tooltip`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={mainData}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={page}
            setIsOpen={(e) => {}}
          />
        </div>
      )}

      {opentimelinepopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <ReimbursementReqTxnDetailsPopup
            reimburse_request_id={RequestId}
            closePopup={() => {
              SetopenTimelinePopup(false);
            }}
            RequestHeader={"Request details"}
            type={"reimbursereq_details"}
            flow={"request_additional"}
          />
        </div>
      )}

      {openRequestpopup && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            setopenRequestpopup(false);
          }}
        >
          <ReimbursementReqTxnDetailsPopup
            reimburse_request_id={RequestId}
            closePopup={() => {
              setopenRequestpopup(false);
            }}
            RequestHeader={"Request details"}
            type={"reimbursereq_details"}
          />
        </div>
      )}

      {isDrawerOpen && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <ReimbursementAccountDetailsPopup
            reimburse_account_id={BeneTxnDetailsId}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            type={"reimburseacc_details"}
          />
        </div>
      )}

      {showPopup && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          {" "}
          <SmallPopupWithInput
            headerTitle={TEXT.REJECT_REQUEST}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
            noteText={TEXT?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
            isTextInputField={true}
            inputPlaceholder="Reason"
            inputAdornment={false}
            subtextwithbullet="Y"
            bulletPoints={[
              "Once rejected, a new request should be created and no transaction will be initiated.",
            ]}
            inputVariant={reasonVariant}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText={TEXT?.CANCEL}
            btnOneHandleFunction={() => {
              setCurrentBtnClicked((c) => {
                return {
                  ...c,
                  [deniedId]: "none",
                };
              });
              if (!showLoader) {
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT?.REJECT}
            btnTwoHandleFunction={() => {
              if (!isReasonValid || showLoader) {
                return;
              }
              handleReject(deniedId, declineReason).finally((x) => {
                setCurrentBtnClicked((c) => {
                  return {
                    ...c,
                    [deniedId]: "none",
                  };
                });
              });
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={!isReasonValid || showLoader}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      <div className="flex flex-col w-width-full h-screen bg-primary-bg pb-pagination-height">
        <div
          className={`w-width-full hidden Qsmd:block h-navbar-breadcrumb-height ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} flex-shrink-0`}
        ></div>
        <div className="flex flex-col items-center justify-center shadow-box-shadow-bottom bg-primary-nav w-full-width z-z-index-overlay relative">
          <TopNavComponent
            direction={direction}
            handleBack={() => navigate(-1)}
            topNavCtaBtn2Needed={false}
            BottomHeader={undefined}
            isSelectionView={false}
            isToggleNeeded={true}
            toggleProps={{
              state: true,
              title: "Multi approval",
              isDisabled: showSearchBar,
              handleClick: () =>
                navigate(
                  "/reimbursement_transaction_dashboard/reimbursement_request_multi_select",
                ),
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: noTransactionsFromAPI
                ? true
                : allBeneTxnAccountsLoading
                  ? true
                  : false,
              onSearchInput: (val) => setSearchUserTextDebounce(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search request",
              filterPlaceholder: "Category / Labels",
              filterItems: [
                {
                  name: "Category",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  displayValue: displayCategory,
                  setValue: (val) => {
                    const c =
                      categories.filter((x) => x.id === val)[0]?.name ?? "";
                    setDisplayCategory(c);
                    setPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                    handleSubmit("category", val);
                    handleSubmit("dispCat", c);
                  },
                  isDropdown: true,
                },
              ],
              isSearchClearAllDisabled: !currentCategory?.length,
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>

        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center pb-padding-xl Qsmd:pb-padding-base relative">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div
            className="flex flex-col gap-gap-md py-padding-md w-width-full px-padding-md Qlg:px-padding-base overflow-y-auto"
            onScroll={handleScroll}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="w-width-full  h-full flex items-center justify-center">
                <Loader />
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="no_pending_transaction"
                  />
                </div>
                <p className="text-sm text-text-primary">
                  There are no more transactions that require <br /> your
                  approval.
                </p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Go to dashboard"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() =>
                    navigate("/reimbursement_transaction_dashboard")
                  }
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-sm m-auto">
                <div>
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="no data found"
                  />
                </div>
                <p className="text-sm text-text-primary">No data found.</p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() => {
                    handleClearFilters();
                  }}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              reimbursementRequestApprovalData === undefined ||
              AllReimburseTxnAccounts?.map((account) => {
                const overlay = getTxnOverlayConfig({
                  account,
                  loading,
                  openTxn: () => {
                    // navigate(
                    //   `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account.request_id}`,
                    //   {
                    //     state: {
                    //       isViewAll: location.pathname.includes("view_all"),
                    //     },
                    //   },
                    // );
                    setopenRequestpopup(true);
                    setRequestId(account?.request_id);
                  },
                  openAccountDrawer: () =>
                    SideDrawerOpen(
                      account.beneficiary_account_id,
                      account.request_id,
                    ),
                });

                const alerts = [];

                /**
                 * @type {import("../../../components/_utils/CommonTransactionApprovalCard/index.jsx").Entry[][]}
                 */
                const entries = [
                  [
                    {
                      type: "textSubtextX2",
                      isBold: true,
                      text: `INR ${FormatAmount({
                        price: account?.requested_amount || "0",
                      })}`,
                      subText: "Amount",
                      textColor: "var(--settled)",
                      text1:
                        account?.category_id?.category_name || "Not available",
                      subText1: "Category",
                    },
                    {
                      type: "textSubtext",
                      text: account?.beneficiary_account_name,
                      subText: "Account name",
                    },

                    {
                      type: "textSubtext",
                      text: account?.created_by_name,
                      subText: "User ID",
                    },
                  ],
                ];

                return (
                  <div
                    key={account.txn_id}
                    className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content"
                  >
                    <CommonTransactionApprovalCard
                      overrideAutoLoader
                      whichBtnClicked={
                        currentBtnClicked?.[account.request_id] ?? "none"
                      }
                      accountApprovalPending={
                        account.lifecycle_status === "pending" &&
                        account.beneficiary_account_approval_status ===
                          "pending" &&
                        !loading[account.txn_id]
                      }
                      entries={entries}
                      alerts={alerts}
                      cardState={overlay.cardState}
                      overlay1Text={overlay.overlay1Text}
                      overlay1Subtext={overlay.overlay1Subtext}
                      overlay1CtaText={overlay.overlay1CtaText}
                      overlay1CtaOnClick={overlay.overlay1CtaOnClick}
                      overlay1Cta1Color={overlay?.overlay1Cta1Color}
                      overlay2Text={overlay.overlay2Subtext}
                      overlay2Subtext={overlay.overlay2Text}
                      overlay1SubtextColor={overlay?.overlay1SubtextColor}
                      approveClick={() => {
                        if (
                          services?.includes("AReimbursementRequest") ||
                          services?.includes("Admin")
                        ) {
                          const updatedAccountDetails = {
                            category_ids: [account?.category_id.category_id],
                            request_id: account?.request_id,
                            bankAccountName: account?.beneficiary_account_name,
                            beneAccountId: account?.beneficiary_account_id,
                            bankAccountIFSC:
                              account?.beneficiary_account_ifsc_code,
                            bankAccountNo:
                              account?.beneficiary_account_bank_acc_no,
                            categories: account?.category_id?.category_name,
                            amount: account?.requested_amount,
                            settleType: account?.payment_method,
                            bankLogo: account?.beneficiary_account_ifsc_code,
                            pan: "",
                            ownerId: null,
                            ownerAccountName: "",
                            ownerBankIFSC: null,
                            ownerBankBalance:
                              GlobalConfiguration.lengthCheckZero,
                            ownerBankLogo: null,
                            ownerLastUpdated: null,
                            ownerBankAccountNo: null,
                            selectedCategory: {
                              configuration: account?.additional_data,
                            },
                            mergeCategory: account?.additional_data?.data,
                            amountInWords: "",
                            labels: account?.labels || [],
                            ownerLabels: [],
                            comment: "",
                            date: account?.reimbursement_date,
                            expenseType: account?.expense_type,
                            description:
                              currentAccountDetails?.description ?? "",
                            uploadFile: account?.uploaded_file_data,
                            uploadURL: account?.uploaded_file_url,
                          };

                          setcurrentAccountDetails(updatedAccountDetails);

                          navigate(
                            "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
                            {
                              state: {
                                ...updatedAccountDetails,
                                type: "PayReimburseTxn",
                                flow: "PayReimburseTxn",
                                TypeRTGS: "RequestRTGS",
                              },
                            },
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService:
                                "AReimbursementRequest, Admin",
                            },
                          });
                        }
                      }}
                      rejectClick={() => {
                        setCurrentBtnClicked((c) => {
                          return { ...c, [account.request_id]: "reject" };
                        });

                        if (overlay.allowApproveReject) {
                          handleOpenPopup(account.request_id);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService:
                                "AReimbursementRequest, Admin",
                            },
                          });
                        }
                      }}
                      approveBtnText={
                        <>
                          Approve & <br />
                          pay
                        </>
                      }
                      rejectBtnText={
                        <>
                          Reject
                          <br />
                          request
                        </>
                      }
                      DestinationNotRequired={true}
                      createdByRequired={true}
                      createdOnSubtext={"Created on"}
                      createdOnText={account?.created_on}
                      createdByText={account?.created_by_name}
                      createdOnRequired={true}
                      destinationAccountNumber={
                        account.beneficiary_account_bank_acc_no
                      }
                      destinationAccountIfsc={
                        account.beneficiary_account_ifsc_code
                      }
                      destinationAccountNumberSubtext="Destination account"
                      destinationAccountText={
                        account?.beneficiary_account_ifsc_code
                      }
                      destinationAccountSubtext="IFSC code"
                      ctaBtn1Text="More details"
                      ctaBtn1OnClick={() => {
                        setopenRequestpopup(true);
                        setRequestId(account?.request_id);
                      }}
                      overlay1Icon={overlay.overlay1Icon}
                      overlay1IconColor={overlay.overlay1IconColor}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div
          className={`h-pagination-height ${showInnerSearchBar ? "hidden " : " hidden Qsmd:block"} w-width-full `}
        ></div>
      </div>
    </>
  );
};

export default ReimbursementRequestSingleApproval;
